import { useFormContext, useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { RadioGroup } from "@/components/ui/radio-group"
import { RadioGroupItemCustom } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-group-item"
import { TeleconsultationForm } from "@/modules/patients/agenda/teleconsultation/booking/teleconsultation-schema"
import { MedgateConnectChannel } from "@/types/__generated__/union-types"

const CommunicationRecipientSelection = ({
  onRecipientChange,
}: {
  onRecipientChange: (value: MedgateConnectChannel) => void
}) => {
  const { t } = useTranslation()
  const { control } = useFormContext<TeleconsultationForm>()
  const addressSource = useWatch({ control, name: "addressSource" })
  const radioValue = addressSource === "PARTNER" ? "PARTNER" : "PATIENT"

  const recipients: { value: MedgateConnectChannel; label: string }[] = [
    { value: "PATIENT", label: t("patient.agenda.communicationRecipient.patient") },
    { value: "PARTNER", label: t("patient.agenda.communicationRecipient.partner") },
  ]

  return (
    <div className="grid gap-2">
      <label className="text-on-surface-subdued text-sm">{t("patient.agenda.communicationRecipient.label")}</label>
      <RadioGroup
        value={radioValue}
        className="flex flex-wrap gap-2"
        onValueChange={(v) => {
          const recipient = recipients.find((r) => r.value === v)
          if (recipient) onRecipientChange(recipient.value)
        }}>
        {recipients.map(({ value, label }) => (
          <RadioGroupItemCustom key={value} groupName="communication-recipient" value={value} label={label} />
        ))}
      </RadioGroup>
    </div>
  )
}

export { CommunicationRecipientSelection }
